import React, { useId } from 'react';
import { Stack, TextField, Typography } from '@mui/material';

/** Keep account labels clear of both the outline and its focus/error ring. */
export default function AccountField({ label, id, required = false, error = false, ...props }) {
  const generatedId = useId();
  const fieldId = id || generatedId;
  return (
    <Stack spacing={1.25} sx={{ width: '100%' }}>
      <Typography component="label" htmlFor={fieldId} sx={{ fontSize: '0.875rem', fontWeight: 500, color: error ? 'error.main' : 'text.secondary' }}>
        {label}{required && <span aria-hidden="true"> *</span>}
      </Typography>
      <TextField {...props} id={fieldId} required={required} error={error} fullWidth />
    </Stack>
  );
}
